export const terminalMap = {
    1: { label: "Front Door", icon: "ri-door-open-line", color: "#198754" },
    2: { label: "Mezzanine", icon: "ri-building-line", color: "#0d6efd" },
    4: { label: "Rahul's Office", icon: "ri-user-star-line", color: "#b45309" },
    5: { label: "Shipping", icon: "ri-truck-line", color: "#534AB7" },
};

// Owner rule (2026-10-02): a dashboard punch from OUTSIDE the company network is
// marked Remote by the API (TimeClock.Remote, from the TimeClock:OfficeNetworks
// setting). HR sees the same mark on the payroll time card.
export const REMOTE_LOCATION = {
    label: "Remote (outside the company network)",
    icon: "ri-home-wifi-line",
    color: "#dc3545",
};

// networksKnown: the API's officeNetworksKnown. While the company network list is not
// set, a stored Remote = false only means "unknown", so the label stays neutral
// (owner finding 2026-10-02: a phone on mobile data read "company network").
export const getPunchLocation = (terminalId, computer, remote, networksKnown) => {

    // 1. Biometric punch — terminal_id is set
    if (terminalId && terminalMap[terminalId]) {
        return terminalMap[terminalId];
    }

    // 2. Dashboard punch — terminal_id is null, use computer name
    if (computer && computer.trim() !== "") {
        if (remote === true) return REMOTE_LOCATION;

        const pc = computer.trim().toUpperCase();
        const serverMachines = ["SSWDB", "SSWMAIN", "SSWSERVER"];

        if (serverMachines.includes(pc)) {
            return {
                label: "On-Site (Dashboard)",
                icon: "ri-computer-line",
                color: "#6c757d",
            };
        }

        if (remote === false && networksKnown === true) {
            return {
                label: "Dashboard (company network)",
                icon: "ri-computer-line",
                color: "#0d6efd",
            };
        }

        return {
            label: `Dashboard (${computer.trim()})`,
            icon: "ri-remote-control-line",
            color: "#0d6efd",
        };
    }

    // 3. Unknown
    return {
        label: "Unknown",
        icon: "ri-question-line",
        color: "#aaa",
    };
};